// extracted by mini-css-extract-plugin
module.exports = {"container":"BigFiveDetails_container__3_BSY"};